module.exports = __webpack_public_path__ + "assets/img/cl_logo_white.f03da9ba.svg";